import { ADD_VARIANT } from './constants';

export const addVariant = (variant) => ({
    type: ADD_VARIANT,
    variant,
});
